export const initBlockData = {
  title: "Ticket change and return",
  text1: "<p>Please enter the information in the fields below to find and manage your booking.</p>",
  text2: "<p>Ticket change and return rules</p>"
};

export const initEmptyBlockData = {
  title: "",
  text1: "",
  text2: ""
};
